import { ShieldAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router'

export function AccessDeniedPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <main
      id='main-content'
      tabIndex={-1}
      className='flex min-h-screen items-center justify-center bg-linear-to-br from-blue-50 to-slate-100 p-4'
    >
      <div className='w-full max-w-lg'>
        <div className='mb-6 flex justify-center'>
          <img src='/engen-logo.png' alt='EnGen' className='h-8' />
        </div>
        <div className='overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl'>
          <div className='flex flex-col items-center px-8 pt-10 pb-6'>
            <div className='mb-6 rounded-full bg-slate-100 p-4'>
              <ShieldAlert className='h-10 w-10 text-slate-600' strokeWidth={1.5} />
            </div>
            <h1 className='text-center text-2xl font-semibold tracking-tight text-slate-900'>
              {t('accessDeniedPage.title')}
            </h1>
          </div>
          <div className='px-8 pb-6'>
            <p className='text-center leading-relaxed text-slate-600'>{t('accessDeniedPage.description')}</p>
          </div>
          <div className='border-t border-slate-100 bg-slate-50/50 px-8 py-6'>
            <Link
              to='/'
              className='block w-full rounded-lg bg-slate-900 px-4 py-3 text-center text-sm font-medium text-white transition-colors duration-200 hover:bg-slate-800'
            >
              {t('accessDeniedPage.goHomeButton')}
            </Link>
            <div className='mt-4'>
              <button
                type='button'
                onClick={() => navigate(-1)}
                className='w-full text-center text-sm text-slate-500 underline-offset-2 hover:text-slate-700 hover:underline'
              >
                {t('accessDeniedPage.goBackLink')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}
